var _style, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRollOfDumpster30M3Lv30(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 841.9 595.3"
    },
    viewBox: "71 92 689 401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .Roll_Of_Dumpster_30m3_LV30_svg__st0{fill:currentColor}.Roll_Of_Dumpster_30m3_LV30_svg__st1{opacity:.4;fill:#1d1d1b;enable-background:new}.Roll_Of_Dumpster_30m3_LV30_svg__st2{fill:#1d1d1b;enable-background:new;opacity:.1}.Roll_Of_Dumpster_30m3_LV30_svg__st3{opacity:.3}.Roll_Of_Dumpster_30m3_LV30_svg__st4{fill:#040506}.Roll_Of_Dumpster_30m3_LV30_svg__st5{opacity:.3;fill:#040506;enable-background:new}.Roll_Of_Dumpster_30m3_LV30_svg__st6,.Roll_Of_Dumpster_30m3_LV30_svg__st7{fill:#040506;enable-background:new}.Roll_Of_Dumpster_30m3_LV30_svg__st8{enable-background:new}.Roll_Of_Dumpster_30m3_LV30_svg__st6{opacity:.1}.Roll_Of_Dumpster_30m3_LV30_svg__st7{opacity:.8}.Roll_Of_Dumpster_30m3_LV30_svg__st8{opacity:.1;fill:#fff}.Roll_Of_Dumpster_30m3_LV30_svg__st10{fill:#010101}.Roll_Of_Dumpster_30m3_LV30_svg__st9{opacity:.2;fill:#010101}.Roll_Of_Dumpster_30m3_LV30_svg__st10{opacity:.3}.Roll_Of_Dumpster_30m3_LV30_svg__st11{opacity:.2;fill:#fff}\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    width: "100%",
    height: "100%",
    viewBox: "0 0 405 356"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 405,
    height: 356,
    href: ""
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-2",
    width: "100%",
    height: "100%",
    viewBox: "0 0 216 203"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 216,
    height: 203,
    href: ""
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Container_1_00000150080867258729734230000009683787311044845705_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Bakgrund_\\xC4ndra_F\\xE4rg",
    d: "m73.2 103 207.4-10.9 479.3 34.5v13.8l-6.4.8.9 235.1-22 57.8-26.2 9.2v18.4l-5.3 3.2-10.1 3.9-31.7-8.5-14 5v19l-7.8 4.8-10.8 3.7-32.1-9.6-15.1 5.7-76.4-23.9-34.9 11.5-13.5-4.1.2-22.5-21.1-6.4-36 11-12.2-4.1v-21.8l-14.5-4.6-37.2 10.1-12.2-3.4v-22.3l-8.5-2.5-38.8 9.9-10.6-3.2v-22.3l-3.7-.9-40.2 9.4-9.4-3V374l-40.2 8.7-9.2-2.8v-19l-37.4 7.3-8.3-2.3v-22l-1.8-.2-28 5.5v5l-4.4.8-7.8-2.1V116.1h-1.6l.1-13.1h1.5z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Skugga_60_x25__00000068646193059414045070000009969948713427581568_",
    d: "M280.7 94.6v24.3L105 103.6l175.7-9z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Highlight_5_x25__00000134214815114470139220000009728047512214810504_",
    d: "M280.7 94.6v24.3l269.5 25.4 174-16.6-443.5-33.1z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Roll_Of_Dumpster_30m3_LV30_LogoA",
    transform: "translate(71.6,92)",
    d: "m75.087 98.41h233.79v149.61h-233.79z",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Roll_Of_Dumpster_30m3_LV30_LogoB",
    transform: "translate(71.6,92)",
    d: "m532.44 110.36h132.54v89.877h-132.54z",
    fill: "url(#pattern-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Skugga_30_x25__00000090976722777892238920000010145989141000593048_",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st3",
    transform: "translate(313.591 121.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25174",
    d: "m345.5 338.5 27.2-9.8-.1 17-27.1-7.2z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25179",
    d: "m312.8 371.3 7.5-4.9 11.2-3.7-7.8 4.8-10.9 3.8z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25180",
    d: "m376.8 347.1 5.6-3.8 10.1-3.3-5.3 3.2-10.4 3.9z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Skugga_30_x25__00000072270909547360402940000006837076633911974531_",
    transform: "translate(5.318 13.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25181",
    d: "m462.6 143.3 5.6.6-.1 262.6 29.4 44.8-34.9 11.5V143.3z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25182",
    d: "m392.2 136.2 4.8.5-.9 250.6 32.1 42.5-36 11V136.2z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25183",
    d: "m328.4 129.3 4.3.5-.4 239.9 33.3 40.5-37.2 10.1v-291z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25184",
    d: "m268.9 123.1 4.2.5.3 229.6 34.3 38.9-38.8 9.9V123.1z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25185",
    d: "m214.5 116.9 4.3.6.2 220.5 35.7 37.5-40.2 9.4v-268z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25186",
    d: "m165 112.1 4.6.5v16.3L165 138v4.8l4.6-8.9 10.3-20.3 2.3.3-12.6 24.6-.5 185.7 36 35.9-40.2 8.7.1-256.7z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25187",
    d: "m118.4 107.2 4.6.5v203.5l32.8 30.1v5.7l-37.4 7.3V107.2z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25188",
    d: "m75.9 102.7 4.4.5.5 196.4 27.5 30.3-28 5.5v5l-4.6.7.2-238.4z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Skugga_30_3",
    d: "m365.9 133.3 2.7.2 11.4 22-.1 4.6-14-26.8",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Skugga_10_x25__00000109744617159632168360000013126725334297280145_",
    d: "M550.6 149.1v17.2l209.3-25.9v-13.8l-209.3 22.5",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Skugga_60-80__x25_",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st3",
    transform: "translate(8.172 125.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25189",
    d: "m466 296.1 76.4 20.7 28.7 47-76.4-23.8-28.7-43.9z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25190",
    d: "m393.2 275.9 52.8 14.2.5 34.7-21.1-6.4-32.2-42.5z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25191",
    d: "m329.4 258.4 33.3 40.5 14.5 4.6-.2-33-47.6-12.1z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25192",
    d: "m270.6 241.8 43 11.7-.2 29.7-8.5-2.5-34.3-38.9z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25193",
    d: "M255.5 265.1v-27.4l-39.4-11 35.7 37.5 3.7.9z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25194",
    d: "M202.3 248.8v-26.6l-36-9.3 36 35.9z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25195",
    d: "M152.9 230v-21.1l-32.8-9 32.8 30.1z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Path_25196",
    d: "m105.4 218.6 1.8.2v-22.7l-29.4-7.8 27.6 30.3z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Highlight_10_x25__00000174571070967958522240000009584256352039560363_",
    d: "M71.7 103v13.1h1.5v236.8L81 355l.2-238.4 34 3.9.2 245.6 8.3 2.3V121.1l37.9 4.1-.5 254.8 9.2 2.8v-226l15.1-29.2 24.7 2.6v265.7l9.9 3v-268l43.6 5.3v276.5l10.8 3.2V137l47.5 5.3v288.5l11.9 3.4v-291l33.5 3.9 1 .1 16.9 32.3v271l12.4 4.1V150l57.6 6.2v316.2l12.9 4.1V157.2l82.6 9.2v-17.2L71.7 103zm98.6 22.9 12.4 1.4-12.4 24.5v-25.9zM385.2 174l-14-26.9 14.1 1.5-.1 25.4z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Skugga_20_x25__00000167391013665083809410000014845209430461407403_",
    d: "m675.6 318.9.8 1.2.5 1 1 .9c3.6 1.9 4.3-1.2 4.6-2.5.2-1.2-.7-4-1.3-5.3-.5-1.3-3.3-3.6-3.3-3.6l-2.6-1.7v-1.2l8.2 1.5v25.2l-4.6 7.8v10l1-.3V350l6.8-1.7V343l9.4 2.1v120l-5.5 3.7.2.1 10.1-3.9 5.3-3.2v-18.4l26.2-9.2 22-57.8-1-235.1L551 166.2l-.4 275.8 28.7 47 15.1-5.7 28.1-9.7-.5-117.9.4-198.3 4.3-.6-.2 195.6 11.4-20.6V329l7.5-14.1 1.1-.5 5.4 1 3.2.6-1 .6-19.8 38.1-.1 133.3-7.2 4.8 10.4-3.6 7.8-4.8v-19l14.3-5.1 26.8 7.2.1-17 3.9-1.6v-7.6l-45 15.8.1-4.5 41.4-14.6v-77.3l1.1-.3 2.4-3.5V349l-44.7 12.6v-1.8l1.9-.6 3.6.8 1-.3V358l23.5-6.6v-32.5m10.8-7.8.3-161.7 4.1-.4.2 167.5-4.6-5.4z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Skugga_30_x25__00000131358545680423124140000007018426257012691117_",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m701.4 329-10.2-12.2-.5-.6-4.2-5-1.9-2.3-1 .3v25.2l1-.3 11.5 11v120l10.1-3.4V334.8z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m680 351.9-.3-10.9-.7 1.1v9.9l-27 7.7-.3-12.7 2.5-4.7 1-.3v-18.2c3.8-4.3 9.3-8.2 14.4-8.1 2.9.1 5.5 1.8 6.9 4.3.5 1.2 1.3 2 2.8 2.5 1.7.3 3.1-1 3.3-3.1 0 0 .7-6.8-7.3-10.5-1.4-.6-2.9-1.1-4.4-1.4-6.2-1.3-13.7 2.9-18.8 8l3.2.6-1 .6-5.8 11-14.2 26.9v133.5l11.2-3.7V359.3l1.9-3.7 3-5.7.3-.5.3 10.6-5.7 1.6v7.6l44.9-12.9V349l-10.2 2.9zm-53.4.6 11.3-20.7.4-176.4-11.5 1.4zM699 147.8l-8.2 1.2.2 167.6 7.9 9.5z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st10"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_30m3_LV30_svg__Highlight_20_x25__00000107585243755997315290000008343876914326605698_",
    d: "m746.2 125.7-196 18.6L105 103.6l175.7-9 444.9 33.1 20.6-2-465.6-33.6c-.1 0 .1 0 0 0L71.7 103l478.9 46.1 209.3-22.5-13.7-.9z",
    className: "Roll_Of_Dumpster_30m3_LV30_svg__st11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollOfDumpster30M3Lv30);
export default __webpack_public_path__ + "static/media/Roll_Of_Dumpster_30m3_LV30.866a976ec1b409f0a68de5dccf65225a.svg";
export { ForwardRef as ReactComponent };